"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unobserve = exports.observe = exports.observingCollection = void 0;
require("intersection-observer");
var finder_1 = require("@medv/finder");
exports.observingCollection = {};
function serializeIntersectionObserverOptions(options) {
    if (!options) {
        return '';
    }
    var serializer = {
        root: function (root) {
            if (!root) {
                return '';
            }
            return finder_1.default(root);
        },
        rootMargin: function (rootMargin) {
            return rootMargin || '';
        },
        threshold: function (threshold) {
            if (threshold === undefined) {
                return '';
            }
            return String(threshold);
        },
    };
    return Object.keys(serializer)
        .map(function (key) {
        // @ts-ignore TODO fix types
        return serializer[key](options[key]);
    })
        .join('; ');
}
function intersectionObserverCallback(entries) {
    entries.forEach(function (entry) {
        var el = entry.target;
        if (entry.isIntersecting && !el.appeared) {
            el.appeared = true;
            var appearEvent = new CustomEvent('appear', {
                detail: entry,
            });
            el.dispatchEvent(appearEvent);
        }
        else if (el.appeared) {
            delete el.appeared;
            var disappearEvent = new CustomEvent('disappear', { detail: entry });
            el.dispatchEvent(disappearEvent);
        }
    });
}
function getObserving(options) {
    var serialized = serializeIntersectionObserverOptions(options);
    var observing = exports.observingCollection[serialized];
    if (observing) {
        return observing;
    }
    var intersectionObserver = new IntersectionObserver(intersectionObserverCallback, options);
    var newObserving = {
        serializedOptions: serialized,
        intersectionObserver: intersectionObserver,
        elements: [],
    };
    exports.observingCollection[serialized] = newObserving;
    return newObserving;
}
function observe(el, options) {
    if (!el) {
        return;
    }
    var observing = getObserving(options);
    if (observing.elements.indexOf(el) === -1) {
        observing.intersectionObserver.observe(el);
        observing.elements.push(el);
    }
}
exports.observe = observe;
function unobserve(el, options) {
    if (!el) {
        return;
    }
    // strict observing retrieving
    var observing = getObserving(options);
    var elements = observing.elements, intersectionObserver = observing.intersectionObserver, serializedOptions = observing.serializedOptions;
    if (elements.indexOf(el) !== -1) {
        intersectionObserver.unobserve(el);
        elements.splice(elements.indexOf(el), 1);
        if (!elements.length) {
            intersectionObserver.disconnect();
            delete exports.observingCollection[serializedOptions];
        }
    }
}
exports.unobserve = unobserve;
